import { render, staticRenderFns } from "./YourExpertiseForm.vue?vue&type=template&id=58eb8904"
import script from "./YourExpertiseForm.vue?vue&type=script&lang=js"
export * from "./YourExpertiseForm.vue?vue&type=script&lang=js"
import style0 from "./YourExpertiseForm.vue?vue&type=style&index=0&id=58eb8904&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58eb8904')) {
      api.createRecord('58eb8904', component.options)
    } else {
      api.reload('58eb8904', component.options)
    }
    module.hot.accept("./YourExpertiseForm.vue?vue&type=template&id=58eb8904", function () {
      api.rerender('58eb8904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/AccountSetup/YourExpertiseForm.vue"
export default component.exports